import { render, staticRenderFns } from "./DilekceOlusturForm.vue?vue&type=template&id=22bad2ad&scoped=true"
import script from "./DilekceOlusturForm.vue?vue&type=script&lang=ts"
export * from "./DilekceOlusturForm.vue?vue&type=script&lang=ts"
import style0 from "./DilekceOlusturForm.vue?vue&type=style&index=0&id=22bad2ad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bad2ad",
  null
  
)

export default component.exports